import { Route, Routes } from "react-router-dom";
import PageLayoutComponent from "../components/layout.components";
import { ScrollToTop } from "../components/ui/scroll.to.top.component";
import { HomePage } from "../pages/home.page";
import NewsPage from "../pages/news.page";
import { NormativeBasePage } from "../pages/normative.base.page";
import NotFoundPage from "../pages/not.found.page";
import PrivacyPolicyPage from "../pages/privacy.policy.page";
import { RepairWorkPage } from "../pages/repair.work.page";
import { RequestsPage } from "../pages/requests.page";
import SingleNewsPage from "../pages/single.news.page";
import { StatisticsPage } from "../pages/statistics.page";
import { ROUTES } from "./routes";

function Routing() {
  return (
      <PageLayoutComponent>
        <ScrollToTop />
        <Routes>
          <Route path={ROUTES.HOME} element={<HomePage />} />
           <Route path={ROUTES.REPAIR_WORK} element={<RepairWorkPage/>} />
           <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
           <Route path={ROUTES.STATISTICS} element={<StatisticsPage />} /> 
           <Route path={ROUTES.NORMATIVE_BASE} element={<NormativeBasePage />} />
           <Route path={ROUTES.NEWS} element={<NewsPage />} />
           <Route path={ROUTES.SINGLE_NEWS} element={<SingleNewsPage />} />
           <Route  path={ROUTES.REQUESTS} element={<RequestsPage/>}/>
           <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
        </Routes>
      </PageLayoutComponent>
  );
}

export default Routing;